module.exports = __webpack_public_path__ + "img/titlescreen.91e93a6c.png";